export const pasos = {
  thank: {
    path: "/graciasCajaAhorro",
    component: "views/GraciasCajaAhorro",
    pasoSiguiente: "infoCelular",
    subtitulo:
      "Te enviaremos tu tarjeta de débito, dentro de los próximos 10 días hábiles a ",
    creado: [
      "Creá tu Usuario y Clave y validá tu celular para operar en Banca Online",
      "Validá tu celular para operar en Banca Online"
    ],
    ingresa:
      "Desde Banca Online podés gestionar tus operaciones de manera ágil.",
    link: [
      "Crear mi Usuario y Clave<br>y validar mi celular",
      "Validar mi celular"
    ],
    item3:
      "Recordá que tu caja de ahorro estará vinculada a tu Tarjeta Visa débito existente."
  },
  mensaje: {
    path: "/mensaje/:mje",
    component: "views/Mensaje"
  },
  clienteCA: {
    titulo: "Obtené tu CBU y comenzá a usar tu cuenta",
    descripcion:
      "Te pedimos que ingreses a Banca Online con tu usuario y clave digital para obtener tu número de cuenta y CBU",
    footerText: "",
    beneficiosTitulo: "Con tu caja de ahorro:",
    beneficios: [
      {
        label: "Pagá todos tus servicios desde tu casa",
        description:
          "Desde Banca Online vas a poder pagar tus servicios a través de tu cuenta."
      },
      {
        label:
          "Depositá y extraé dinero en cajeros automáticos BBVA las 24 horas",
        description: ""
      },
      {
        label: "Accedé a Banca Online y BBVA Móvil",
        description:
          "Transferí, consultá y operá desde tu computadora o celular."
      },
      {
        label: "Adherí tus pagos e impuestos al débito automático",
        description: "Y olvidate de hacer largas filas."
      }
    ]
  },
  mensajeErrorSolicitudCuenta: {
    path: "/mensajeSolicitudCuenta/:mje",
    component: "views/MensajeErrorSolicitudCuenta",
    header: "Solicitud de Cuenta",
    titulo: "Esta oferta no está disponible",
    texto:
      "Ingresá a Banca Online y conocé los productos a los que podés acceder."
  }
};

export const premios = [
  {
    label: "Cajeros BBVA <br/>las 24 horas",
    icon: "bbva-branch.png"
  },
  {
    label:
      "Comprá en cualquier comercio adherido sin tener que llevar efectivo",
    icon: "loan-dollar.png"
  },
  {
    label: "Banca Online y BBVA móvil",
    icon: "devices.png"
  }
];

export const beneficios = [
  {
    label: "<strong>Sin comisión de apertura ni de mantenimiento</strong>",
    description:
      "Sin costos de apertura, mantenimiento, movimientos de fondos y consultas de saldo en cajeros BBVA."
  },
  {
    label: "Cargá el saldo de tu <strong>SUBE o celular</strong>",
    description: "Todas las veces que quieras desde Banca Online."
  },
  {
    label: "<strong>Pagá todos tus servicios desde tu casa</strong>",
    description:
      "Desde Banca Online vas a poder pagar tus servicios a través de tu cuenta."
  },
  {
    label:
      "Depositá y extraé dinero en cajeros automáticos <strong>BBVA</strong> las 24 horas",
    description: ""
  },
  {
    label:
      "Accedé a <strong>Banca Online</strong> y <strong>BBVA Móvil</strong>",
    description: "Transferí, consultá y operá desde tu computadora o celular."
  },
  {
    label: "Adherí tus pagos e impuestos al débito automático",
    description: "Y olvidate de hacer largas filas."
  }
];
